import aries from "@/assets/img/zodiac/ic_aries.png";
import taurus from "@/assets/img/zodiac/ic_taurus.png";
import gemini from "@/assets/img/zodiac/ic_gemini.png";
import cancer from "@/assets/img/zodiac/ic_cancer.png";
import leo from "@/assets/img/zodiac/ic_leo.png";
import virgo from "@/assets/img/zodiac/ic_virgo.png";
import libra from "@/assets/img/zodiac/ic_libra.png";
import scorpio from "@/assets/img/zodiac/ic_scorpio.png";
import sagittarius from "@/assets/img/zodiac/ic_sagittarius.png";
import capricorn from "@/assets/img/zodiac/ic_capricorn.png";
import aquarius from "@/assets/img/zodiac/ic_aquarius.png";
import pisces from "@/assets/img/zodiac/ic_pisces.png";

export enum ZodiacType {
    ARIES = "aries",
    TAURUS = "taurus",
    GEMINI = "gemini",
    CANCER = "cancer",
    LEO = "leo",
    VIRGO = "virgo",
    LIBRA = "libra",
    SCORPIO = "scorpio",
    SAGITTARIUS = "sagittarius",
    CAPRICORN = "capricorn",
    AQUARIUS = "aquarius",
    PISCES = "pisces",
}

export interface ZodiacDomain {
    id: number;
    name: string;
    zodiacType: ZodiacType  ;
    image: string;
}


const ZODIAC: ZodiacDomain[] = [
    {
        id: 0,
        name: "Овен",
        zodiacType: ZodiacType.ARIES,
        image: aries,
    },
    {
        id: 1,
        name: "Телец",
        zodiacType: ZodiacType.TAURUS,
        image: taurus,
    },
    {
        id: 2,
        name: "Близнецы",
        zodiacType: ZodiacType.GEMINI,
        image: gemini,
    },
    {
        id: 3,
        name: "Рак",
        zodiacType: ZodiacType.CANCER,
        image: cancer,
    },
    {
        id: 4,
        name: "Лев",
        zodiacType: ZodiacType.LEO,
        image: leo,
    },
    {
        id: 5,
        name: "Дева",
        zodiacType: ZodiacType.VIRGO,
        image: virgo,
    },
    {
        id: 6,
        name: "Весы",
        zodiacType: ZodiacType.LIBRA,
        image: libra,
    },
    {
        id: 7,
        name: "Скорпион",
        zodiacType: ZodiacType.SCORPIO,
        image: scorpio,
    },
    {
        id: 8,
        name: "Стрелец",
        zodiacType: ZodiacType.SAGITTARIUS,
        image: sagittarius,
    },
    {
        id: 9,
        name: "Козерог",
        zodiacType: ZodiacType.CAPRICORN,
        image: capricorn,
    },
    {
        id: 10,
        name: "Водолей",
        zodiacType: ZodiacType.AQUARIUS,
        image: aquarius,
    },
    {
        id: 11,
        name: "Рыбы",
        zodiacType: ZodiacType.PISCES,
        image: pisces,
    },
]

export const getZodiacByName = (name: string): ZodiacDomain | null => {
    return ZODIAC.find(zodiac => zodiac.zodiacType === name) || null;
}
